<template>
<div class="detail_body">
		<!-- <v-head
		title="抬头信息"
		:sdata="sdata"></v-head> -->
  <div class="coll">
    <h2 class="title"><span>BOM明细</span></h2>
    <tab-list :tabList="sdata" :columns="tabColumns" setHeadBtn tabName="base-bom-detail" tabHeight="500">
    </tab-list>
  </div>
</div>
</template>

<script>
import vHead from './detail/head.vue';
import tabList from 'components/table/list.vue';
export default{
  props:{
    sdata:Array
  },
	components:{
		vHead,
		tabList
	},
	data(){
		return{
      tabColumns:[
        {field: 'projectClassify', title: '项目类别', width:100,"sortable":true},
        {field: 'bomComponent', title: '组件编码'},
        {field: 'bomComponentDesc', title: '组件描述'},
        {field: 'componentNum', title: '数量'},
        {field: 'compUnitDesc', title: '计量单位'},
        {field: 'materialDesc', title: '组装件'},
        {field: 'startDate', title: '有效起始日期'},
        {field: 'removeMark', title: '删除标志'},
       
      ],//表头字段
		}
	},
	created(){

	},
	methods:{
	}
}
</script>

<style>
</style>
